import React from "react";
import { useAppContext } from "../../helpers/account-context";
import {
  getDistanceFromLatLonInKm,
  getDistanceFromLatLonInMi,
} from "../../helpers/helper";
import { ResultLine, DetailLine, InfowinLine } from "./Mixin";

const DistanceTag = (props) => {
  const {
    currentGeo,
    account: { distance_unit },
    getLocale,
  } = useAppContext();

  const { item } = props;
  const distanceKm = getDistanceFromLatLonInKm(
    item.properties.lat,
    item.properties.lng,
    currentGeo.lat,
    currentGeo.lng
  );
  
  const distanceMi = getDistanceFromLatLonInMi(
    item.properties.lat,
    item.properties.lng,
    currentGeo.lat,
    currentGeo.lng
  );
  return (
    <div className="cbmap-distance-badge">
      {distance_unit === "km" ? distanceKm : distanceMi}
      <span>
        {" "}
        {distance_unit === "km" ? getLocale("km_aways") : getLocale("mi_aways")}
      </span>
    </div>
  );
};

export const DistanceResult = (props) => {
  const { currentGeo } = useAppContext();
  if (!currentGeo || !currentGeo.lat || !currentGeo.lng) return null;

  return (
    <ResultLine className="cbmap-item_distance">
      <DistanceTag {...props} />
    </ResultLine>
  );
};

export const DistanceDetail = (props) => {
  const { currentGeo } = useAppContext();
  if (!currentGeo || !currentGeo.lat || !currentGeo.lng) return null;

  return (
    <DetailLine className="cbmap-details_distance">
      <DistanceTag {...props} />
    </DetailLine>
  );
};

export const DistanceInfowin = (props) => {
  const { currentGeo } = useAppContext();
  if (!currentGeo || !currentGeo.lat || !currentGeo.lng) return null;

  return (
    <InfowinLine className="cbmap-infowin_distance">
      <DistanceTag {...props} />
    </InfowinLine>
  );
};
